import { auth, firestore } from '../firebase'
import {
  REQUEST_AUTH_DATA,
  RECEIVE_AUTH_DATA,
  RESET_AUTH_DATA,
  RESET_ACCOUNT_DATA,
  RECEIVE_ACCESSIBLE_ACCOUNTS,
  SET_CURRENT_ACCOUNT
} from './types'

const createAccountOnce = (authUser) =>{
  const accountData = {
    createdAt: Date.now(),
    name: authUser.email
  }

  return firestore.collection('accounts').doc(authUser.uid).set(
    accountData,
    { merge: true }
  ).then(() => ({...accountData, id: authUser.uid}) )
}

export const updateAccount = (values) =>
  (dispatch, getState) => {
    const state = getState()
    if(!state.account || !state.account.currentAccountId) return Promise.resolve(null)

    return firestore.collection('accounts').doc(state.account.currentAccountId).set(
      values,
      { merge: true }
    )
  }


// handle accessible accounts
const listenForAccessibleAccounts = (accountId) =>
  dispatch => {
    const stopListening1 = firestore.collection('accounts')
                                    .doc(accountId)
                                    .onSnapshot((snapshot) => {
      const updates = { added: [], removed: [], modified: [] }
      updates.modified.push({...snapshot.data(), id: snapshot.id})
      dispatch({ type: RECEIVE_ACCESSIBLE_ACCOUNTS, updates })
    }, error => console.log('ERROR:::::',error,Object.keys(error)))

    const stopListening2 = firestore.collection('accounts')
             .where("sharedWith","array-contains",accountId)
             .onSnapshot( snapshot => {
      const updates = { added: [], removed: [], modified: [] }

      snapshot.docChanges().forEach( change => {
        if(updates[change.type]) updates[change.type].push(
          {...change.doc.data(), id:change.doc.id}
        )
      })

      dispatch({ type: RECEIVE_ACCESSIBLE_ACCOUNTS, updates })
    }, error => console.log('ERROR:::::',error,Object.keys(error)))
    return () => {
      if(stopListening1) stopListening1()
      if(stopListening2) stopListening2()
    }
}

export const setCurrentAccountId = (id) => ({ type: SET_CURRENT_ACCOUNT, id })

// handle login / logout
export const listenForAuthStatusChanges = () =>
  dispatch => {
    dispatch({type: REQUEST_AUTH_DATA })
    // listen for auth status changes
    // bind unsubscriber
    let stopListeningForAccessibleAccounts;

    const stopListeningAuthStatusChanges = auth.onAuthStateChanged(user => {
      // create or update user account
      if(user) {
        createAccountOnce(user).then(account => {
          dispatch({type: RECEIVE_AUTH_DATA, user, account})
          stopListeningForAccessibleAccounts = dispatch(listenForAccessibleAccounts(account.id))
        })

      } else {
        // handle logout
        dispatch({type: RESET_AUTH_DATA })
      }
    })

    // return combined unsubscriber
    return () => {
      if (stopListeningAuthStatusChanges) stopListeningAuthStatusChanges()
      if (stopListeningForAccessibleAccounts) stopListeningForAccessibleAccounts()
    }
  }

const resetData = () => (
  {
    type: RESET_ACCOUNT_DATA
  }
)

// Sign Up
export const createUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password)

// Sign In
export const signinWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password)

// Sign out
export const signout = () =>
  dispatch => {
    dispatch(resetData())
    return auth.signOut()
  }

// Password Reset
export const resetPassword = email =>
  auth.sendPasswordResetEmail(email)

// Password Change
export const updatePassword = password =>
  auth.currentUser.updatePassword(password)


export const sendEmailVerification = () =>
  auth.currentUser.sendEmailVerification()



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/actions/account.js